import React, { useCallback, useMemo } from 'react';
import { topicsData, ITopic } from 'config/topics';
import { NavigationItem } from 'components/Navigation/NavigationItem/NavigationItem';
import styled from 'styled-components/macro';
import { useTypedSelector } from 'redux/reducers';
import { useDispatch } from 'react-redux';
import { updateTopic } from 'redux/actions/topicAction';
import { ITopicHover } from 'components/Frame/Frame';
import { sortBy } from 'lodash-es';

const StyledNavigation = styled.nav`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  display: flex;
  z-index: 10;
`;


const Navigation: React.FC<ITopicHover> = React.memo(({ hoveredTopic, setHoveredTopic }) => {
  const activeTopic = useTypedSelector((state) => state.topic.selected);
  const dispatch = useDispatch();
  const topics = useMemo(() => sortBy(topicsData, ['id']), []);

  const handleNavItemClick = useCallback((id: number) => {
    dispatch(updateTopic(topics[id]));
  }, [dispatch, topics]);

  const handleTopicMouseOver = useCallback((topic: ITopic) => () => {
    setHoveredTopic(topic);
  }, [setHoveredTopic]);

  const handleTopicMouseLeave = useCallback(() => {
    setHoveredTopic(undefined);
  }, [setHoveredTopic]);

  return (
    <StyledNavigation>
      {topics.map((x) => x.id !== 0 && (
        <NavigationItem
          key={x.id}
          topic={x}
          onClick={handleNavItemClick}
          active={activeTopic.id === x.id || hoveredTopic?.id === x.id}
          onMouseOver={handleTopicMouseOver(x)}
          onMouseLeave={handleTopicMouseLeave}
        />
      ))}
    </StyledNavigation>
  );
});

export { Navigation };
